<template>
<!--    热点资讯-->
  <div id="newslist">
    <h2 class="title">
      <a @click="back" class="prev"></a>
      热点资讯
    </h2>
    <div id="zjgx">
      <div class="main">
        <ul>
          <a :href="item.href_url" v-for="(item, index) in recentData" :key="index">
            <li>
              <div class="left">
                <img :src="item.img ? item.img : require('../../assets/img/home_zjgx_pic1.png')" alt="">
              </div>
              <div class="right">
                <p>
                  {{item.title}}
                </p>
                <div class="tag">
                  {{item.time}}
                </div>
              </div>
            </li>
          </a>
        </ul>
      </div>
    </div>
    <p v-if="has" class="cue">--上划加载更多--</p>
    <p v-else class="cue">--到底啦 只有这么多了--</p>
    <p class="loading" v-show="loading">努加加载中...</p>
  </div>
</template>

<script>
export default {
  name: 'NewsList',
  data () {
    return {
      recentData: [],
      page: 1,
      length: 8,
      loading: false,
      maxPage: 0,
      has: true
    }
  },
  methods: {
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    // 获得最近更新
    getRecent () {
      let data = {
        page: this.page, // 第几页
        length: this.length // 每页条数
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_all_news',
        params: data,
        headers: {
          'sign': this.$encryption(data)
        }
      })
        .then(res => {
          this.recentData = [...this.recentData, ...res.data.data.info]
          if (!res.data.data.has) {
            $(window).unbind('scroll')
          }
        })
        .catch(err => { console.log(err) })
    },
    listenScroll () {
      let self = this
      $(window).scroll(function () {
        let scrollTop = $(window).scrollTop()
        let windowTop = $(window).height()
        let documentTop = $(document).height()
        if (documentTop - windowTop <= scrollTop) {
          self.page++
          self.loading = true
          self.getRecent()
          self.loading = false
        }
      })
    }
  },
  mounted () {
    this.getRecent()
    this.listenScroll()
  },
  beforeDestroy () {
    $(window).unbind('scroll')
  }
}
</script>

<style scoped lang="stylus">
  #newslist
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 500
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
  #zjgx
    width: 7.1rem
    padding: 0 .2rem .3rem
    background-color: #fff
    margin: 0 auto
    -webkit-border-radius: .16rem
    -moz-border-radius: .16rem
    border-radius: .16rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .main
      li
        display: flex
        justify-content: space-between
        width: 100%
        height: 1.86rem
        padding: .32rem 0
        border-bottom: .01rem solid #EFEFEF
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        .left
          width: 1.6rem
          height: 1.24rem
          -webkit-border-radius: .08rem
          -moz-border-radius: .08rem
          border-radius: .08rem
          img
            width: 100%
        .right
          width: 4.9rem
          height: 1.24rem
          p
            overflow: hidden
            width: 100%
            height: .84rem
            font-size: .3rem
            color: #0C0C0C
          p + .tag
            font-size: .22rem
            color: #9DA4B3
            text-align: right
  p.cue
    text-align: center
</style>



// WEBPACK FOOTER //
// src/components/single/NewsList.vue